// Spanish translations for react-admin (ra-language-english) and ra-supabase,
// which ship no Spanish package compatible with react-admin v5.
export const spanishRaMessages = {
  ra: {
    action: {
      add_filter: "Añadir filtro",
      add: "Añadir",
      back: "Volver",
      bulk_actions:
        "1 elemento seleccionado |||| %{smart_count} elementos seleccionados",
      cancel: "Cancelar",
      clear_array_input: "Vaciar la lista",
      clear_input_value: "Borrar valor",
      clone: "Duplicar",
      confirm: "Confirmar",
      create: "Crear",
      create_item: "Crear %{item}",
      delete: "Eliminar",
      edit: "Editar",
      export: "Exportar",
      list: "Lista",
      refresh: "Actualizar",
      remove_filter: "Quitar este filtro",
      remove_all_filters: "Quitar todos los filtros",
      remove: "Quitar",
      reset: "Restablecer",
      save: "Guardar",
      search: "Buscar",
      search_columns: "Buscar columnas",
      select_all: "Seleccionar todo",
      select_all_button: "Seleccionar todo",
      select_row: "Seleccionar esta fila",
      show: "Ver",
      sort: "Ordenar",
      undo: "Deshacer",
      unselect: "Deseleccionar",
      expand: "Desplegar",
      close: "Cerrar",
      open_menu: "Abrir menú",
      close_menu: "Cerrar menú",
      update: "Actualizar",
      move_up: "Subir",
      move_down: "Bajar",
      open: "Abrir",
      toggle_theme: "Cambiar modo claro/oscuro",
      select_columns: "Columnas",
      update_application: "Recargar la aplicación",
    },
    boolean: {
      true: "Sí",
      false: "No",
      null: " ",
    },
    page: {
      create: "Crear %{name}",
      dashboard: "Inicio",
      edit: "%{name} %{recordRepresentation}",
      error: "Algo ha ido mal",
      list: "%{name}",
      loading: "Cargando",
      not_found: "No encontrado",
      show: "%{name} %{recordRepresentation}",
      empty: "Todavía no hay %{name}.",
      invite: "¿Quieres añadir uno?",
      access_denied: "Acceso denegado",
      authentication_error: "Error de autenticación",
    },
    input: {
      file: {
        upload_several:
          "Arrastra aquí los archivos o haz clic para seleccionar uno.",
        upload_single:
          "Arrastra aquí un archivo o haz clic para seleccionarlo.",
      },
      image: {
        upload_several:
          "Arrastra aquí las imágenes o haz clic para seleccionar una.",
        upload_single:
          "Arrastra aquí una imagen o haz clic para seleccionarla.",
      },
      references: {
        all_missing: "No se encuentran los datos de referencia.",
        many_missing:
          "Al menos una de las referencias asociadas ya no está disponible.",
        single_missing: "La referencia asociada ya no está disponible.",
      },
      password: {
        toggle_visible: "Ocultar contraseña",
        toggle_hidden: "Mostrar contraseña",
      },
    },
    message: {
      about: "Acerca de",
      access_denied: "No tienes permisos para acceder a esta página",
      are_you_sure: "¿Seguro?",
      authentication_error:
        "El servidor de autenticación ha devuelto un error y no se han podido comprobar tus credenciales.",
      auth_error: "Error al validar el token de autenticación.",
      bulk_delete_content:
        "¿Seguro que quieres eliminar este %{name}? |||| ¿Seguro que quieres eliminar estos %{smart_count} elementos?",
      bulk_delete_title:
        "Eliminar %{name} |||| Eliminar %{smart_count} %{name}",
      bulk_update_content:
        "¿Seguro que quieres actualizar %{name} %{recordRepresentation}? |||| ¿Seguro que quieres actualizar estos %{smart_count} elementos?",
      bulk_update_title:
        "Actualizar %{name} %{recordRepresentation} |||| Actualizar %{smart_count} %{name}",
      clear_array_input: "¿Seguro que quieres vaciar toda la lista?",
      delete_content: "¿Seguro que quieres eliminar este %{name}?",
      delete_title: "Eliminar %{name} %{recordRepresentation}",
      details: "Detalles",
      error:
        "Se ha producido un error y no se ha podido completar la solicitud.",
      invalid_form: "El formulario no es válido. Revisa los errores",
      loading: "Espera un momento",
      no: "No",
      not_found: "La URL no es correcta o el enlace está roto.",
      select_all_limit_reached:
        "Hay demasiados elementos para seleccionarlos todos. Solo se han seleccionado los primeros %{max}.",
      unsaved_changes:
        "Hay cambios sin guardar. ¿Seguro que quieres descartarlos?",
      yes: "Sí",
      placeholder_data_warning:
        "Problema de red: no se han podido actualizar los datos.",
    },
    navigation: {
      clear_filters: "Quitar filtros",
      no_filtered_results: "No hay %{name} con los filtros actuales.",
      no_results: "No hay %{name}",
      no_more_results:
        "La página %{page} está fuera de rango. Prueba con la anterior.",
      page_out_of_boundaries: "Página %{page} fuera de rango",
      page_out_from_end: "No hay más páginas",
      page_out_from_begin: "No hay páginas antes de la 1",
      page_range_info: "%{offsetBegin}-%{offsetEnd} de %{total}",
      partial_page_range_info:
        "%{offsetBegin}-%{offsetEnd} de más de %{offsetEnd}",
      current_page: "Página %{page}",
      page: "Ir a la página %{page}",
      first: "Ir a la primera página",
      last: "Ir a la última página",
      next: "Ir a la página siguiente",
      previous: "Ir a la página anterior",
      page_rows_per_page: "Filas por página:",
      skip_nav: "Saltar al contenido",
    },
    sort: {
      sort_by: "Ordenar por %{field_lower_first} %{order}",
      ASC: "ascendente",
      DESC: "descendente",
    },
    auth: {
      auth_check_error: "Inicia sesión para continuar",
      user_menu: "Perfil",
      username: "Usuario",
      password: "Contraseña",
      email: "Email",
      sign_in: "Iniciar sesión",
      sign_in_error: "No se ha podido iniciar sesión, inténtalo de nuevo",
      logout: "Cerrar sesión",
    },
    notification: {
      updated:
        "Elemento actualizado |||| %{smart_count} elementos actualizados",
      created: "Elemento creado",
      deleted: "Elemento eliminado |||| %{smart_count} elementos eliminados",
      bad_item: "Elemento incorrecto",
      item_doesnt_exist: "El elemento no existe",
      http_error: "Error de comunicación con el servidor",
      data_provider_error:
        "Error del dataProvider. Revisa la consola para más detalles.",
      i18n_error: "No se han podido cargar las traducciones de este idioma",
      canceled: "Acción cancelada",
      logged_out: "Tu sesión ha terminado. Vuelve a iniciar sesión.",
      not_authorized: "No tienes permiso para acceder a este recurso.",
      application_update_available: "Hay una versión nueva disponible.",
      offline: "Sin conexión. No se han podido cargar los datos.",
    },
    validation: {
      required: "Obligatorio",
      minLength: "Debe tener al menos %{min} caracteres",
      maxLength: "Debe tener %{max} caracteres o menos",
      minValue: "Debe ser al menos %{min}",
      maxValue: "Debe ser %{max} o menos",
      number: "Debe ser un número",
      email: "Debe ser un email válido",
      oneOf: "Debe ser uno de: %{options}",
      regex: "Debe tener un formato concreto (regexp): %{pattern}",
      unique: "Debe ser único",
    },
    saved_queries: {
      label: "Búsquedas guardadas",
      query_name: "Nombre de la búsqueda",
      new_label: "Guardar búsqueda actual...",
      new_dialog_title: "Guardar búsqueda actual como",
      remove_label: "Eliminar búsqueda guardada",
      remove_label_with_name: 'Eliminar búsqueda "%{name}"',
      remove_dialog_title: "¿Eliminar búsqueda guardada?",
      remove_message:
        "¿Seguro que quieres quitar este elemento de tus búsquedas guardadas?",
      help: "Filtra la lista y guarda esta búsqueda para más tarde",
    },
    guesser: {
      empty: {
        title: "No hay datos que mostrar",
        message: "Revisa tu proveedor de datos",
      },
    },
    configurable: {
      customize: "Personalizar",
      configureMode: "Configurar esta página",
      inspector: {
        title: "Inspector",
        content:
          "Pasa el ratón por los elementos de la interfaz para configurarlos",
        reset: "Restablecer ajustes",
        hideAll: "Ocultar todo",
        showAll: "Mostrar todo",
      },
      Datagrid: {
        title: "Tabla",
        unlabeled: "Columna sin nombre #%{column}",
      },
      SimpleForm: {
        title: "Formulario",
        unlabeled: "Campo sin nombre #%{input}",
      },
      SimpleList: {
        title: "Lista",
        primaryText: "Texto principal",
        secondaryText: "Texto secundario",
        tertiaryText: "Texto terciario",
      },
    },
  },
  "ra-supabase": {
    auth: {
      email: "Email",
      confirm_password: "Confirmar contraseña",
      sign_in_with: "Iniciar sesión con %{provider}",
      forgot_password: "¿Has olvidado la contraseña?",
      reset_password: "Restablecer contraseña",
      password_reset:
        "Revisa tu email: te hemos enviado un mensaje para restablecer la contraseña.",
      missing_tokens: "Faltan los tokens de acceso y de actualización",
      back_to_login: "Volver a iniciar sesión",
    },
    reset_password: {
      forgot_password: "¿Has olvidado la contraseña?",
      forgot_password_details:
        "Escribe tu email y te enviaremos instrucciones.",
    },
    set_password: {
      new_password: "Elige tu contraseña",
    },
    validation: {
      password_mismatch: "Las contraseñas no coinciden",
    },
    oauth: {
      authorize: "Autorizar aplicación",
      authorize_details: "Esta aplicación quiere acceder a tu cuenta.",
      access_scope:
        "Podrá leer y modificar tus datos, con los mismos permisos que tu cuenta.",
      approved: "Autorización concedida",
      close_tab: "Ya puedes cerrar esta pestaña.",
      no_request: "No se ha encontrado ninguna solicitud de autorización",
    },
  },
};
